// extracted by mini-css-extract-plugin
module.exports = {"root":"IconBtn_root__1ggmW"};